<template>
  <div>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <v-card>
            <v-container fluid>
              <v-layout row wrap align-center justify-space-between>
                <v-flex lg4>
                  <v-btn icon color="primary" class="ma-auto mr-1" @click="this.getList">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                  <v-btn :to="{ name: 'ServersAdd' }" icon color="primary" class="ma-auto mr-1">
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex lg4>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex md12>
                  <div class="py-3"></div>
                  <v-data-table
                    dense
                    :loading="isLoading"
                    :headers="headers"
                    :items="list"
                    :search="search"
                    :options.sync="pagination"
                    :rowsPerPageItems="rowsPerPageItems"
                  >
                    <template v-slot:item="props">
                      <tr>
                        <td class="justify-center pa-1 ">
                          <v-btn color="info" icon small :to="{ name: 'ServersEdit', params: { id: props.item.sid }}" class="ma-auto mr-1">
                            <v-icon small>edit</v-icon>
                          </v-btn>
                          <v-btn color="blue-grey" icon small :to="{ name: 'ServersJobs', params: { id: props.item.sid }}" class="white--text ma-auto mr-1">
                            <v-icon small>text_rotation_none</v-icon>
                          </v-btn>
                          <v-btn color="error" icon small :href="`ssh://${props.item.susername}@${props.item.sip}:${props.item.sport}`" class="ma-auto">
                            <v-icon small>input</v-icon>
                          </v-btn>
  <!--                        <a :href="'ssh://'+props.item.susername+'@'+props.item.sip+':'+props.item.sport">-->
  <!--                          <v-icon small>input</v-icon>-->
  <!--                        </a>-->
                        </td>
                        <td v-for="value in props.item" :key="value" class="pa-1">{{ value }}</td>
                      </tr>
                    </template>

                    <template v-slot:no-data>
                      <div class="pa-2 text-xs-center">No data available.</div>
                    </template>

                    <template v-slot:no-results>
                      <div class="pa-2 text-xs-center">Your search for "{{ search }}" found no results.</div>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
<!--  <v-card>-->
<!--    <v-card-title>-->
<!--      <router-link :to="{ name: 'servers_add'}">-->
<!--        <v-icon small class="mr-2">add</v-icon>-->
<!--      </router-link>-->
<!--      <v-spacer></v-spacer>-->
<!--      <div class="my-2">-->
<!--        <v-btn small color="primary" @click="this.getList">update list</v-btn>-->
<!--      </div>-->
<!--    </v-card-title>-->
<!--    <v-data-table-->
<!--      dense-->
<!--      :headers="headers"-->
<!--      :items="list"-->
<!--      :search="search"-->
<!--      :options.sync="pagination"-->
<!--      :rowsPerPageItems="rowsPerPageItems"-->
<!--      class="elevation-1"-->
<!--    >-->
<!--      <template v-slot:items="props">-->
<!--        <td class="justify-center">-->
<!--          <router-link :to="{ name: 'servers_edit', params: { id: props.item.sid }}">-->
<!--            <v-icon small class="mr-1">edit</v-icon>-->
<!--          </router-link>-->
<!--          <router-link :to="{ name: 'servers_jobs', params: { id: props.item.sid }}">-->
<!--            <v-icon small class="mr-1">text_rotation_none</v-icon>-->
<!--          </router-link>-->
<!--          <a :href="'ssh://'+props.item.susername+'@'+props.item.sip+':'+props.item.sport">-->
<!--            <v-icon small class="mr-2">input</v-icon>-->
<!--          </a>-->
<!--        </td>-->
<!--        <td v-for="value in props.item">{{ value }}</td>-->
<!--      </template>-->
<!--      <v-alert-->
<!--        v-slot:no-results-->
<!--        :value="true"-->
<!--        color="error"-->
<!--        icon="warning"-->
<!--      >Your search for "{{ search }}" found no results.</v-alert>-->
<!--    </v-data-table>-->
<!--  </v-card>-->
</template>

<script>
export default {
  data() {
    return {
      search: "",
      schema: [],
      list: [],
      rowsPerPageItems: [
        10,
        20,
        40,
        80,
        160,
        { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
      ],
      pagination: {
        rowsPerPage: 40
      },
      isLoading: false,
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    headers() {
      const headers = [];

      headers.push({
        text: 'Actions',
        value: 'name',
        sortable: false
      });

      for (const key in this.schema.properties) {
        if (this.schema.properties[key]['x-list']) {
          const { title } = this.schema.properties[key];

          headers.push({
            text: title,
            value: key,
            align: 'left'
          });
        }
      }

      return headers;
    }
  },
  methods: {
    async getList() {
      this.isLoading = true;

      const schemaResponse = await this.$api.servers.getSchema();
      this.schema = await schemaResponse.data;

      const listResponse = await this.$api.servers.getList();
      this.list = await listResponse.data.result;
      this.isLoading = false;
    },
  }
};
</script>

<style>
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/servers/list.vue